<template>
   <Form :model="formData" class="config-form" >
     <FormItem v-for="(item,index) in configData"
               :key="index"
               :label-width="150"
               :label="getLable(item)"
               :prop="formData[item.menuName]+`-`+index" class="config-form-item">
               <!--:rules="renderRules(item)"-->
       <Tooltip :content="item.configDesc" placement="top" theme="light">
         <Icon type="ios-alert-outline" />
       </Tooltip>
       <Input type="text" v-model="formData[item.menuName]"
              v-if="item.fieldType==='text' && item.inputType==='input'"
              :style="{'width':item.width}" :placeholder="item.configDesc">
       </Input>
       <InputNumber v-model="formData[item.menuName]"
                    v-if="item.fieldType==='text' && item.inputType==='number'">

       </InputNumber>
       <ColorPicker v-model="formData[item.menuName]" v-if="item.fieldType==='text' && item.inputType==='color'"/>
       <DatePicker type="datetime" confirm v-if="item.inputType==='date'"></DatePicker>
       <!-- </FormItem>

        <FormItem v-for="(item,index) in configData" :prop="item.info"
                  :key="index" :label-width="130" v-if="item.fieldType !== 'text'">
       <Tooltip :content="item.configDesc" theme="light" placement="top">
         <Icon type="ios-alert-outline" />
       </Tooltip>-->
       <Input  type="textarea" v-model="formData[item.menuName]"
               :rows="item.height"
               :style="{'width':item.width}"
               v-if="item.fieldType === 'textarea'" :placeholder="item.configDesc">
       </Input>
        <EntitySelect  v-if="item.fieldType === 'entity'"  v-model="formData[item.menuName]"  :fieldConfig="formData.entityConfig"
        :queryUrl="formData.entityConfig.requestUrl" style="width: 30%;">
       </EntitySelect> 
       <RadioGroup v-model="formData[item.menuName]"  v-if="item.fieldType === 'radio'">
         <Radio :label="radioItem.value" :key="`radio`+item.id+radioItem.value" v-for="radioItem in renderParams(item)">
           <span>{{radioItem.label}}</span>
         </Radio>
       </RadioGroup>
       <CheckboxGroup v-model="formData[item.menuName]"  v-if="item.fieldType === 'checkbox'">
         <Checkbox :label="checkItem.value" v-for="checkItem in renderParams(item)" :key="`checkbox`+item.id+checkItem.value">
           <span>{{checkItem.label}}</span>
         </Checkbox>
       </CheckboxGroup>
       <Select v-model="formData[item.menuName]" v-if="item.fieldType === 'select'">
         <Option :label="selectItem.value" v-for="selectItem in renderParams(item)" :key="`select`+item.id+selectItem.value">{{ selectItem.label }}</Option>
       </Select>
       <div class="file-upload-list" v-if="item.fieldType === 'upload' && formData[item.menuName]">
         <template>
           <img :src="formData[item.menuName]">
           <div class="file-upload-list-cover">
             <Icon type="ios-eye-outline" @click.native="handleView(formData[item.menuName])"></Icon>
             <Icon type="ios-trash-outline" @click.native="handleRemove(item.menuName)"></Icon>
           </div>
         </template>
       </div>
       <div class="fc-upload-btn" :ref="`uploadBtn`+index" @click="openUploadPanel(item.menuName,index,item.width,item.height)"
            v-if="item.fieldType === 'upload' && !formData[item.menuName] && formData[item.menuName] === ''">
         <Icon type="md-camera" size="20"/>
       </div>
     </FormItem>
     <div class="edit-oper-toolbar">
       <Button type="primary" @click="paasFormSubmit">保存</Button>
     </div>
     <FileModal id="fileModal"
                @save-file="saveFileData"
                :thumbnailWidth="thumWidth"
                :thumbnailHeight="thumHeight"
                :uploadParams="uploadParams"
                :uploadAction="uploadAction"
                @on-close="hiddenModal"
                v-if="uploadModal"
                class="paas-file-select" ></FileModal>
     <Modal title="图片预览" v-model="visible">
       <img :src="viewImg" v-if="visible" style="width: 100%">
     </Modal>
   </Form>
</template>

<script>
    import FileModal from '@views/sys/image/select'
    import EntitySelect from '../../../../components/paas/refer/entitySelect.vue';
    export default {
      name: "configForm",
      components:{EntitySelect},
      props:{
        configData:{
          type:Array,
          default:[],
        },
        tabId:{
          type:String,
          default:'',
        }
      },
      data(){
          return{
            formData:{},
            rules:[],
            params:[],
            uploadModal:false,
            uploadList:[],
            visible:false,
            uploadParams: {
              fileBusinessType: 'systemConfig',
              fileBusinessProp: 'photo',
              fileBusinessId: '',
            },
            thumWidth:45,
            thumHeight:45,
            viewImg:'',
            currentUploadParam:'',  //当前点击的是哪个参数的上传数据
          }
      },
      computed:{
        uploadAction(){
          return this.$store.state.sysApi+'/sys/file/uploadAttacheSlice';
        },
      },
      created(){
          if(this.configData != null && this.configData.length > 0){
            for(let i = 0; i <  this.configData.length; i++){
              if(this.configData[i].fieldType === 'entity') {
                let config = JSON.parse(this.configData[i].checkParameter);
                this.formData.entityConfig = config;
              }
              this.formData[this.configData[i].menuName] = this.configData[i].defaultValue;
            }
          }
      },
      methods:{
        /**
         * 打开附件上传模态框
         */
        openUploadPanel(menuName,index,width,height){
          this.currentUploadParam = menuName;
          this.uploadModal = true;
          this.thumWidth = width;
          this.thumHeight = height;
          //计算当前位置的top以及left
          let scrollTop = document.documentElement.scrollTop;
          let top = this.$refs["uploadBtn"+index][0].getBoundingClientRect().top;
          this.$nextTick(()=>{
            document.getElementById("fileModal").style.top = (top+scrollTop-100)+"px";
            document.getElementById("fileModal").style.left = 0;
          });
        },
        /**
         * 隐藏附件弹出框
         */
        hiddenModal(){
          this.uploadModal = false;
        },
        handleRemove(menuName){
          this.formData[menuName] = "";
          this.$forceUpdate();
        },
        handleView(showUrl){
          this.visible = true;
          this.viewImg = showUrl;
        },
        /**
         * 保存图片
         * @param files
         */
        saveFileData(files){
          if(this.currentUploadParam){
            this.formData[this.currentUploadParam] = files[0].thumbnailUrl;
            this.uploadModal = false;
          }
        },
        renderRules(item){
          let rules = [];
          if(item.requiredRules){
            let ruleArr = item.requiredRules.split(",");
            for(let i = 0; i < ruleArr.length; i++){
              let ruleKey = ruleArr[i];
              if(ruleKey === "required:true"){
                let ruleObj = {
                  required:true,
                  message: item.info+'不能为空',
                  trigger: 'blur'
                };
                rules.push(ruleObj);
              }else if(ruleKey === "digits:true"){
                let ruleObj = {
                  type:'integer', //必须是类型number和整数。
                  message: item.info+'必须是整数',
                  trigger: 'blur'
                };
                rules.push(ruleObj);
              }else if(ruleKey === "url:true"){
                let ruleObj = {
                  type:'url', //必须是类型url。
                  message: item.info+'必须是url',
                  trigger: 'blur'
                };
                rules.push(ruleObj);
              }else if(ruleKey === "number:true"){
                let ruleObj = {
                  type:'number', //必须是类型number。
                  message: item.info+'必须是number',
                  trigger: 'blur'
                };
                rules.push(ruleObj);
              }else if(ruleKey === "email:true"){
                let ruleObj = {
                  type:'email', //必须是类型email。
                  message: item.info+'必须是email',
                  trigger: 'blur'
                };
                rules.push(ruleObj);
              }
            }
          }
          return rules;
        },
        renderParams(item){
          let params = [];
          if(item.checkParameter){
            let parameterArr = item.checkParameter.split(/\n/);
            if(parameterArr != null && parameterArr.length > 0){
              for(let i = 0 ; i < parameterArr.length; i++){
                let paramObj = {};
                paramObj.value = parameterArr[i].split("=>")[0];
                paramObj.label = parameterArr[i].split("=>")[1];
                params.push(paramObj);
              }
            }

          }
          return params;
        },
        paasFormSubmit(){
          this.formData.tabId = this.tabId;
          this.$emit('save',this.formData);
        },
        getLable(item){
          let labelName = item.info;
          if(item.fieldType === 'upload' && (item.width !== null && item.width !== 0) && (item.height !== null && item.height !== 0)){
            labelName += "("+item.width+`*`+item.height+"px)";
          }
          labelName += ":";
          return labelName;
        }
      }
    }
</script>

<style scoped>
  @import "../../../../assets/css/file/file-upload.css";
  .config-form{
    position:relative;
  }
  .config-form-item >>> .ivu-form-item-content{
    display:flex;
  }

</style>
